export const getStyle = (isMobile) => {
  return `
    <style>
      img {
        width: 100%;
        height: 100%;
        max-width: ${isMobile ? '300px' : '350px'};
        max-height: ${isMobile ? '300px' : '350px'};
        object-fit: contain;
        object-position: center;
        border-radius: 5px;
      }
    </style>`;
};
